var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersManagementBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1377518,10 C10.3812541,10 10.6007852,10.0115741 10.7972647,10.0327932 L10.8964575,10.0462457 C15.4362082,10.4541787 19.1664317,13.5188573 19.9647473,17.5654169 C19.9882043,17.6843177 20,17.8048213 20,17.9255554 C20,19.0254236 19.0420764,19.9253711 17.8310691,19.9955897 L17.678426,20 L2.32157401,20 L2.16893094,19.9955897 C0.957923613,19.9253711 0,19.0254236 0,17.9255554 C0,17.8048213 0.0117956908,17.6843177 0.0352527351,17.5654169 C0.812637464,13.6249533 4.37020328,10.6155581 8.74816963,10.0837811 L9.10489899,10.0461239 C9.32358125,10.0159499 9.57639761,10 9.86224825,10 L10.1377518,10 Z M10,11.3939355 C5.76856217,11.4552781 2.23693628,14.4719672 1.50834766,18.1650896 L1.50107021,18.2394353 C1.50107021,18.4463819 1.66534663,18.6190395 1.88372771,18.6589676 L1.98031094,18.6676664 L18.1074574,18.6676664 C18.372133,18.6676664 18.5866981,18.4759457 18.5866981,18.2394353 C18.5866981,18.2145114 18.5842631,18.189635 18.5794207,18.1650896 C17.8508321,14.4719672 14.2309671,11.4552781 10,11.3939355 Z M10,8.8817842e-15 C12.4852814,8.8817842e-15 14.4339319,1.99335393 14.4339319,4.47863531 C14.4339319,6.96391668 12.4852814,8.95727061 10,8.95727061 C7.51471863,8.95727061 5.53409091,6.96391668 5.53409091,4.47863531 C5.53409091,1.99335393 7.51471863,8.8817842e-15 10,8.8817842e-15 Z M10,1.3 C8.2362815,1.3 6.83409091,2.70772676 6.83409091,4.47863531 C6.83409091,6.24954385 8.2362815,7.65727061 10,7.65727061 C11.7546489,7.65727061 13.1339319,6.25866674 13.1339319,4.47863531 C13.1339319,2.69860387 11.7546489,1.3 10,1.3 Z",
    id: "Combined-Shape",
    fill: "#3B7FF5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersManagementBorder);
export default __webpack_public_path__ + "static/media/users-management-border.2a8d2438d0204f257da2fc047c336e71.svg";
export { ForwardRef as ReactComponent };